'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const TRACKED_PREFIXES = [
  '/',
  '/how-it-works',
  '/roi-calculator',
  '/quickbooks',
  '/blog',
  '/tools/credit-card-wizard',
  '/case-studies',
  '/team',
  '/all-integrations',
  '/integrations-landing',
  '/sign-in',
  '/sign-up',
];

function isTrackedPath(path: string): boolean {
  if (path === '/') return true;
  return TRACKED_PREFIXES.some(
    prefix =>
      prefix !== '/' && (path === prefix || path.startsWith(prefix + '/'))
  );
}

/**
 * Lightweight page view tracker for public/marketing pages.
 * Uses navigator.sendBeacon for non-blocking, fire-and-forget tracking.
 * Only fires on public paths — authenticated app pages are skipped.
 */
export function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname || !isTrackedPath(pathname)) return;
    if (typeof navigator.sendBeacon !== 'function') return;

    navigator.sendBeacon(
      '/api/track',
      JSON.stringify({ path: pathname, referrer: document.referrer })
    );
  }, [pathname]);

  return null;
}
